export default "__VITE_ASSET__D4AbXM11__"